import { Component, inject, input, model, computed, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-filter-select-component',
  imports: [FormsModule],
  templateUrl: './filter-select-component.html',
  styleUrl: './filter-select-component.scss',
})
export class FilterSelectComponent {
  private locale = inject(LOCALE_ID);
  label = input.required<string>();
  defaultOption = input<string>('All');
  options = input<any[]>([]);
  value = model<any>();
  isArabic = computed(() => this.locale.startsWith('ar'));
}
